export default (process.env.NODE_ENV == 'live' || process.env.NODE_ENV == 'production') ? 'https://doctorboxapi.com' :
			  ((process.env.NODE_ENV == 'local') ? 'http://localhost:8000' : 'https://dev.doctorboxapi.com')
